import { CustomAlert } from "@/components/alerts/CustomAlert";
import {
  avisoDelCierre,
  cajasConVentasSinSubir,
} from "@/context/caja/cajasDelNegocio";
import { estadoDelError } from "@/context/caja/errores";
import { useCajasDelNegocio } from "@/hooks/react-query/Caja/useCajasDelNegocio";
import { pos } from "@/platform";

/**
 * Al cerrar la caja de un local (D16; §2.3 de OFFLINE-POS-RONDA-2.md): qué cajas
 * de escritorio del local están sin señal y todavía pueden vender sin red. Se
 * puede cerrar igual; el aviso no frena el cierre. Pregunta al montarse, y los
 * dos cierres lo montan recién al abrirse: el contenido de un diálogo cerrado no
 * existe. Es sólo del escritorio, como toda la caja offline (D5): en la web no
 * pregunta ni avisa.
 */
export function AvisoDeCajasSinConexion({
  warehouseId,
}: {
  warehouseId: string | null | undefined;
}) {
  const cajas = useCajasDelNegocio(warehouseId ?? null, {
    enabled: pos.isAvailable && !!warehouseId,
  });

  if (cajas.isError) {
    const estado = estadoDelError(cajas.error);
    // Sin el permiso de verlas, o un core sin cajas: no hay nada que avisar.
    if (estado === 403 || estado === 404) return null;
    return (
      <p className="text-xs text-text-secondary">
        No se pudo comprobar si hay cajas de escritorio del local sin conexión.
      </p>
    );
  }

  const aviso = cajas.data
    ? avisoDelCierre(cajasConVentasSinSubir(cajas.data, Date.now()))
    : null;
  return aviso ? (
    <CustomAlert variant="warning" title="Cajas sin conexión" message={aviso} />
  ) : null;
}
